import api from "./api";


export const fetchAgentServices = async () => {

    try {

        const response = await api.get(
            "/agent-service-management/services?active_only=false"
        );

        if (
            response.status === 200 &&
            response.data?.success
        ) {

            return {
                success: true,
                data: response.data.data || [],
            };

        }

        return {
            success: false,
            error:
                response.data?.message ||
                "Unexpected response from server",
        };

    } catch (error) {

        console.error(
            "Error fetching agent services:",
            error.message || error
        );

        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch agent services",
        };

    }
};


export const createAgentService = async (
    payload
) => {

    try {

        const response = await api.post(
            "/agent-service-management/services",
            payload
        );

        if (
            (
                response.status === 200 ||
                response.status === 201
            ) &&
            response.data?.success
        ) {

            return {
                success: true,
                data: response.data.data,
            };

        }

        return {
            success: false,
            error:
                response.data?.message ||
                "Unexpected response from server",
        };

    } catch (error) {

        console.error(
            "Error creating agent service:",
            error.message || error
        );

        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to create agent service",
        };

    }
};



export const updateAgentService = async (
    serviceId,
    payload
) => {

    try {

        const response = await api.put(
            `/agent-service-management/services/${serviceId}`,
            payload
        );

        if (
            response.status === 200 &&
            response.data?.success
        ) {

            return {
                success: true,
                data: response.data.data,
            };

        }

        return {
            success: false,
            error:
                response.data?.message ||
                "Unexpected response from server",
        };

    } catch (error) {

        console.error(
            "Error updating agent service:",
            error.message || error
        );

        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to update agent service",
        };

    }
};



export const deleteAgentService = async (
    serviceId
) => {

    try {

        const response = await api.delete(
            `/agent-service-management/services/${serviceId}`
        );

        if (
            response.status === 200 &&
            response.data?.success
        ) {

            return {
                success: true,
                data: response.data.data,
                message:
                    response.data.message ||
                    "Agent service deleted successfully",
            };

        }

        return {
            success: false,
            error:
                response.data?.message ||
                "Unexpected response from server",
        };

    } catch (error) {

        console.error(
            "Error deleting agent service:",
            error.message || error
        );

        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to delete agent service",
        };

    }
};